import { BiSolidPlaneAlt } from "react-icons/bi";
import { CiCircleList, CiUser } from "react-icons/ci";
import { FaBan, FaBlog, FaUsersSlash } from "react-icons/fa";
import { GiWindyStripes } from "react-icons/gi";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { PiUserListThin } from "react-icons/pi";
import { RiWechatPayFill } from "react-icons/ri";
import { SlSupport } from "react-icons/sl";

const sidebarItems = [
  {
    title: "Dashboard",
    link: "/admin",
    icon: <MdOutlineDashboardCustomize size={"24px"} />,
  },
  {
    title: "Blog",
    link: "/admin/blog-list",
    icon: <FaBlog size={"24px"} />,
    subMenu: [
      {
        title: "Create",
        link: "/admin/blog",
        icon: <FaBlog size={"24px"} />,
      },
      {
        title: "List",
        link: "/admin/blog-list",
        icon: <CiCircleList size={"24px"} />,
      },
    ],
  },
  {
    title: "Posts",
    link: "/admin/post-list",
    icon: <FaBlog size={"24px"} />,
  },
  {
    title: "Tip",
    link: "/admin/tips-list",
    icon: <GiWindyStripes size={"24px"} />,
    subMenu: [
      {
        title: "Create",
        link: "tip",
        icon: <GiWindyStripes size={"24px"} />,
      },
      {
        title: "List",
        link: "tips-list",
        icon: <CiCircleList size={"24px"} />,
      },
    ],
  },
  {
    title: "Trip",
    link: "/admin/trip",
    icon: <BiSolidPlaneAlt size={"24px"} />,
    subMenu: [
      {
        title: "List",
        link: "/admin/trip",
        icon: <CiCircleList size={"24px"} />,
      },
    ],
  },
  {
    title: "User",
    link: "/admin/list",
    icon: <CiUser size={"24px"} />,
    subMenu: [
      {
        title: "List",
        link: "/admin/list",
        icon: <PiUserListThin size={"24px"} />,
      },
      {
        title: "Unverified User",
        link: "/admin/unverified-users",
        icon: <PiUserListThin size={"24px"} />,
      },
      {
        title: "Reported User",
        link: "/admin/reported-users",
        icon: <FaUsersSlash size={"24px"} />,
      },
      {
        title: "Support Message",
        link: "/admin/support",
        icon: <SlSupport size={"24px"} />,
      },
      {
        title: "Disabled User",
        link: "/admin/disabled-users",
        icon: <FaBan size={"24px"} />,
      },
      {
        title: "Subscribe User",
        link: "/admin/subscribe-users",
        icon: <RiWechatPayFill size={"24px"} />,
      },
    ],
  },
];

export default sidebarItems;
